import Vue from 'vue'
import axios from 'axios'
import store from '@/store'
import router from '@/router'

const BASEURL = process.env.NODE_ENV === 'production'
    ? window.location.origin
    : (process.env.VUE_APP_API_BASE_URL || 'https://smmz-dx.zhiqiyf.com')

// 添加请求拦截器
axios.interceptors.request.use(
    function (config) {
        return config
    },
    function (error) {
        // 对请求错误做些什么
        return Promise.reject(error)
    }
)

function clearExpiredAuth(data) {
    if (!data || ![401, 402].includes(Number(data.code)) || data.msg !== '请登录') return

    store.commit('clearAuth')
    if (router.currentRoute.name !== 'login') {
        router.replace({ name: 'login', query: { redirect: router.currentRoute.fullPath } })
    }
}

// 添加响应拦截器
axios.interceptors.response.use(
    function (res) {
        const data = res.data
        clearExpiredAuth(data)
        return data
    },
    function (error) {
        const responseData = error.response && error.response.data
        clearExpiredAuth(responseData)
        if (typeof window.alertErr === 'function') window.alertErr('接口报错了~')
        return Promise.reject(error)
    }
)

export function api(action, method, data) {
    let reqUrl = BASEURL + action //请求地址
    let reqMethod = method ? method.toLowerCase() : 'post' //请求方式
    let reqData = {
        user_id: localStorage.getItem('user_id') || '',
        token: localStorage.getItem('token') || '',
        ...data,
    }

    let otherConfig = {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
    }

    if (reqMethod == 'get') {
        return axios({
            url: reqUrl,
            method: reqMethod,
            params: reqData,
            ...otherConfig,
        })
    } else if (reqMethod == 'post') {
        return axios({
            url: reqUrl,
            method: reqMethod,
            data: reqData,
            ...otherConfig,
        })
    }
}

export function uploadFile(action, file, data = {}) {
    const formData = new FormData()
    formData.append('file', file)
    formData.append('user_id', localStorage.getItem('user_id') || '')
    formData.append('token', localStorage.getItem('token') || '')
    Object.keys(data).forEach((key) => {
        if (data[key] !== undefined && data[key] !== null) formData.append(key, data[key])
    })
    return axios({
        url: BASEURL + action,
        method: 'post',
        data: formData,
        timeout: 120000,
    })
}
